import { render, staticRenderFns } from "./orderDialogue.vue?vue&type=template&id=60a2b7af&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./orderDialogue.vue?vue&type=script&lang=ts&"
export * from "./orderDialogue.vue?vue&type=script&lang=ts&"
import style0 from "./orderDialogue.vue?vue&type=style&index=0&id=60a2b7af&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2b7af",
  null
  
)

export default component.exports